import React from 'react';

import InforPreview from '../../../../../../../../../common/InforPreview';
import SimulationDoneFrozen from '../../../../../../../../../common/SimulationDoneFrozen';
import DialogActionsWrapper from '../DialogActionWrapper';

const ShoppingCartFactoringCompleted = (props: any) => {
  const {
    setOpenShoppingCart,
    selectedRequest,
    setUp,
    selectedId,
    executivesPortfolio,
    executivesAll,
  } = props;
  const infoDiv = (
    <InforPreview
      requestType="factoring"
      type="Recieved"
      status="Completada"
      setUp={setUp}
      selectedRequest={selectedRequest}
      executivesPortfolio={executivesPortfolio}
      executivesAll={executivesAll}
    />
  );

  return (
    <div>
      <div>
        <SimulationDoneFrozen
          selectedRequest={selectedRequest}
          infoDiv={infoDiv}
        />
        <DialogActionsWrapper
          type="factoring"
          onClose={() => setOpenShoppingCart(false)}
          selectedRequest={selectedRequest}
          setUp={setUp}
          selectedId={selectedId}
        />
      </div>
    </div>
  );
};

export default ShoppingCartFactoringCompleted;
